import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { getIntl } from '../../../../utils/intl';
import LabelValueDisplay from '../../../v2BaseComponents/LabelValueDisplay';
import addressToString from '../../../../utils/addressToString';

const intl = getIntl('group-details', {
    name: 'Name',
    description: 'Description',
    address: 'Address',
});

export type GroupDetailsOwnProps = { group: APITypes.organizationService.OrganizationGroupDetails };

export type GroupDetailsProps = GroupDetailsOwnProps;

const GroupDetails: React.FC<GroupDetailsProps> = (props) => {
    return (
        <Stack vertical space={contentStackSpacing}>
            <LabelValueDisplay
                omitEmptyValues
                items={[
                    { label: intl('name'), value: props.group.metadata.name },
                    { label: intl('description'), value: props.group.metadata.description },
                    {
                        label: intl('address'),
                        value: addressToString(props.group.contactDetails),
                    },
                ]}
            />
        </Stack>
    );
};

export default React.memo(GroupDetails);
